import React, { useState } from 'react';
import { IScannerProps } from '@yudiel/react-qr-scanner';
import { Stack, Typography } from '@mui/material';
import TextField from '@ui-lib/components/Inputs/TextField';
import Button from '@ui-lib/components/Button';
import { createSx } from '@ui-lib/utils';

const sx = createSx({
  root: {
    py: 8,
    px: 2,
    height: '100%',
    width: 300,
    position: 'relative',
    boxSizing: 'border-box'
  }
});

const FakeScanner = ({ onScan, children }: IScannerProps) => {
  const [value, setValue] = useState('');

  return (
    <Stack
      sx={sx.root}
      spacing={2}
      alignItems='center'
      justifyContent='center'
    >
      <Typography variant='h6'>
        Fake QR Scanner
      </Typography>
      <Typography variant='body2' textAlign='center'>
        Enter QR code link below and click Scan to simulate a QR code scan.
      </Typography>
      <TextField
        name='qr-scanner'
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />

      <Button
        testID='scan-button'
        onClick={() => {
          onScan([{
            rawValue: value,
            format: 'QR_CODE',
            boundingBox: { x: 0, y: 0, width: 10, height: 10 },
            cornerPoints: []
          }]);

        }}
        disabled={!value}
      >
        Scan
      </Button>
      {children}

    </Stack>
  );
};
export default FakeScanner;
